import React, { memo } from 'react';
import { ZapIcon, ShieldIcon, HeartIcon, DropletIcon } from 'lucide-react';
const FunctionalShots = () => {
  return <section className="py-20 bg-gradient-to-br from-blue-50 via-white to-blue-50" data-id="element-274">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-275">
        <div className="text-center mb-16" data-id="element-276">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full text-sm font-medium bg-blue-500 text-white shadow-sm mb-4" data-id="element-277">
            PATENTED TECHNOLOGY
          </span>
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-278">
            Functional Shots On Demand
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-279">
            Our patented solution offers customizable beverage options designed
            with your team's experience in mind
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-280">
          {/* Energy Shot */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-281">
            <div className="bg-yellow-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-282">
              <ZapIcon className="h-8 w-8 text-yellow-500" data-id="element-283" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-284">
              Energy Shot
            </h3>
            <p className="text-gray-600 text-center" data-id="element-285">
              A refreshing combination organic caffeine and L-Theanine that
              provide a pleasant boost during busy workdays.
            </p>
            <div className="mt-6 text-center" data-id="element-286">
              <span className="inline-block px-3 py-1 bg-yellow-50 text-yellow-700 rounded-full text-sm font-medium" data-id="element-287">
                ⚡ Revitalizing blend
              </span>
            </div>
          </div>
          {/* Immunity Shot */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-288">
            <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-289">
              <ShieldIcon className="h-8 w-8 text-green-500" data-id="element-290" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-291">
              Immunity Shot
            </h3>
            <p className="text-gray-600 text-center" data-id="element-292">
              A carefully selected mix of zinc infused ingredients that many
              people enjoy as part of their daily wellness routine.
            </p>
            <div className="mt-6 text-center" data-id="element-293">
              <span className="inline-block px-3 py-1 bg-green-50 text-green-700 rounded-full text-sm font-medium" data-id="element-294">
                🛡️ Daily ritual
              </span>
            </div>
          </div>
          {/* Alkaline Water */}
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all hover:transform hover:scale-105" data-id="element-295">
            <div className="bg-cyan-100 rounded-full w-16 h-16 flex items-center justify-center mb-6 mx-auto" data-id="element-296">
              <DropletIcon className="h-8 w-8 text-cyan-500" data-id="element-297" />
            </div>
            <h3 className="text-xl font-semibold text-center text-navy-950 mb-4" data-id="element-298">
              Alkaline Water
            </h3>
            <p className="text-gray-600 text-center" data-id="element-299">
              pH-balanced water that offers a refreshing alternative to regular
              water with a smooth taste experience.
            </p>
            <div className="mt-6 text-center" data-id="element-300">
              <span className="inline-block px-3 py-1 bg-cyan-50 text-cyan-700 rounded-full text-sm font-medium" data-id="element-301">
                💧 Refreshing hydration
              </span>
            </div>
          </div>
        </div>
        <div className="mt-16 bg-white p-8 rounded-xl shadow-md max-w-4xl mx-auto" data-id="element-302">
          <h3 className="text-2xl font-bold text-navy-950 mb-4 text-center" data-id="element-303">
            The Ultimate Office Perk
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-304">
            <div data-id="element-305">
              <ul className="space-y-4" data-id="element-306">
                <li className="flex" data-id="element-307">
                  <div className="flex-shrink-0" data-id="element-308">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-309">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-310">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-311" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-312">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-313">
                      Personalized Experience
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-314">
                      Employees can customize their beverages based on their
                      personal preferences throughout the day.
                    </p>
                  </div>
                </li>
                <li className="flex" data-id="element-315">
                  <div className="flex-shrink-0" data-id="element-316">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-317">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-318">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-319" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-320">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-321">
                      Wellness Options
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-322">
                      Support your team with a variety of beverage choices that
                      may complement their wellness routines.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div data-id="element-323">
              <ul className="space-y-4" data-id="element-324">
                <li className="flex" data-id="element-325">
                  <div className="flex-shrink-0" data-id="element-326">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-327">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-328">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-329" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-330">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-331">
                      Enhance Workplace Satisfaction
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-332">
                      Offer a premium perk that employees may appreciate and
                      mention in company reviews.
                    </p>
                  </div>
                </li>
                <li className="flex" data-id="element-333">
                  <div className="flex-shrink-0" data-id="element-334">
                    <div className="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-500" data-id="element-335">
                      <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-336">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-337" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-338">
                    <h4 className="text-lg font-medium text-navy-950" data-id="element-339">
                      Impress Clients & Visitors
                    </h4>
                    <p className="mt-1 text-gray-600" data-id="element-340">
                      Create memorable impressions with a unique beverage
                      experience that stands out from the ordinary.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-341">
            <a href="#book-demo" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-lg shadow-md text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all" data-id="element-342">
              Schedule Your Demo Today
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default FunctionalShots;